import { createFileRoute } from '@tanstack/react-router';

import { AttributesPage, attributesQueryOptions } from '@/features/dictionary';

/**
 * One attribute's editor. It reads the attribute out of the dictionary list, the cache the
 * product editor's option picker shares, so the loader prefetches the list.
 */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/attributes/$attributeId')({
  loader: async ({ context, params }) => {
    const rows = await context.queryClient
      .query({ ...attributesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined);
    const attribute = rows?.find((row) => row.id === params.attributeId);
    return attribute ? { crumb: attribute.label } : {};
  },
  component: AttributesPage,
});
